<template>
  <div class="panelNagusia">
    <div class="ui breadcrumb">
      <a class="section" v-on:click="goTo('/dashboard')">Home</a>
      <i class="right angle icon divider"></i>
      <a class="active section" v-on:click="goTo('/inventory')">Inventario y Actuaciones</a>
      <i class="right angle icon divider"></i>
      <a class="section" v-on:click="goTo('/inventory/column/reservation/list')">Reservas</a>
      <i class="right angle icon divider"></i>
      <a class="active section">Editar Reserva</a>
    </div>

    <h1 class="ui header">
      <i class="icon edit outline"></i>
      <h1 class="content">Editar Reserva</h1>
    </h1>


    <div v-if="!data || !columnNamesOptions || !reservedColumns" class="ui active centered inline loader"></div>
    <div v-else>
      <button v-if="isOwner" class="ui red button rightButton" :class="{ loading: isDeleting, disabled: isDeleting }"
        @click="deleteColumnReservationConfirm">
        <i class="trash alternate outline icon"></i>Eliminar reserva
      </button>
      <form class="ui form">
        <div class="two fields">
          <div class="field">
            <label>Reserva</label>
            <div v-if="isOwner" class="ui action input">
              <input ref="nameInput" type="text" v-model="data.name" :readonly="!editName">
              <button v-if="!editName" class="ui teal button" @click="editReservationName"><i
                  class="ui edit icon"></i>Editar</button>
              <div v-if="editName">
                <div class="ui buttons">
                  <button class="ui red button" @click="cancelEditName"><i class="x icon"></i></button>
                  <div class="or"></div>
                  <button class="ui positive button" @click="saveEditName"><i class="check icon"></i></button>
                </div>
              </div>
            </div>
            <div v-else>
              <input ref="nameInput" type="text" v-model="data.name" readonly>
            </div>
          </div>

          <div class="field">
            <label>Propietario</label>
            <input type="text" v-model="data.administrator_name" readonly>
          </div>
        </div>
      </form>

      <div class="ui section divider hidden"></div>

      <div v-if="storeOptions" class="ui stackable one column">
        <div class="row">
          <h4 class="ui dividing header">Columnas</h4>
          <div class="form ui">
            <selectStock :theIsNew="false" :theBlockStock="!isOwner" theFlujoStock="S" theActionTypeKey=""
              :theStores="storeOptions" :theStockNames="[]" :theColumnNames="columnNamesOptions"
              :theStockSelected="reservedColumns" :theLetAddItem="true" :allowEdit="false"
              @stockSelected="column_selection = $event">
            </selectStock>
          </div>
        </div>
      </div>

      <div class="row" id="idBtn" v-if="showButton">
        <button class="ui button black" :class="[{ loading: isLoading }, { disabled: isLoading }]"
          @click="updateColumnReservation">
          Guardar cambios
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { hapiickApi } from '@/api/hapiickApi';
import { areArraysEqual, userNotification } from '@/tools/Utils';
import selectStock from '@/components/selectStock.vue'

export default {
  name: 'columnBookingInfo',
  props: ['id'],
  data() {
    return {
      data: null,
      storeOptions: [],
      columnNamesOptions: [],
      reservedColumns: [],
      column_selection: [],
      editName: false,
      isLoading: false,
      isDeleting: false,
      isOwner: false,
    }
  },
  created() {
    let role = JSON.parse(localStorage.admin).role;
    if (role === 'master' || role === 'admin') {
      this.getColumnReservationInfo()
      this.getDataFilters()
      this.getColumnsUnreserved()
    } else {
      this.$router.replace('/inventory')
    }
  },

  computed: {
    showButton() {
      return !areArraysEqual(this.reservedColumns, this.column_selection)
    }
  },

  methods: {
    getColumnReservationInfo() {
      hapiickApi().post('/v1/reservations/info', {
        admin_id: JSON.parse(localStorage.admin).id,
        column_reservation_id: this.id
      })
        .then(response => {
          this.loadData(response.data)
        })
        .catch(error => console.log(`Error getColumnReservationInfo: ${error}`))
    },

    getDataFilters() {
      hapiickApi().post('/v2/shipments/filters', {
        admin_id: JSON.parse(localStorage.admin).id,
        Store: true
      })
        .then(request => {
          this.fillStoreOptions(request.data.data.stores);
        })
        .catch((error) => console.log(`Error getDataFilters: ${error}`))
    },

    getColumnsUnreserved() {
      hapiickApi().post('/v1/columns/unreserved', {
        admin_id: JSON.parse(localStorage.admin).id,
      })
        .then(response => {
          this.fillStocksOptions(response.data.columns)
        })
        .catch((error) => console.log(`Error getColumnsUnreserved: ${error}`))
    },

    loadData(data) {
      const { ColumnReservation, Administrator, StockProduct } = data.column_reservation
      this.data = {
        ...ColumnReservation,
        'administrator_name': Administrator.name,
      }

      this.isOwner = JSON.parse(localStorage.admin).id === this.data.administrator_id
      this.name_orig = this.data.name

      this.loadReservedColumns(StockProduct)
    },

    loadReservedColumns(columns) {
      this.reservedColumns = columns.map(a => ({
        id: a.id,
        key: a.id,
        stock_product_id: a.id,
        stock_id: a.stock_id,
        store_id: a.store_id,
        name: a.Stock.name,
        stockType: a.Stock.stock_type,
        store_name: a.Store.name,
        apt_id: a.apt_id,
        apt_name: (a.apt_id > 0) ? a.Apt.LanguagesApts[0].name : '',
        quantity: a.quantity,
        nSlots: a.Stock.n_slots,
        desglose: a.Stock.desglose,
        quantitySelected: a.quantity,
        quantitySelected_orig: a.quantity,
        product_identifier: a.product_identifier,
        product_identifier_prov: a.product_identifier_prov,
        value: a.stock_product_id,
        text: a.Stock.name + ' (' + a.quantity + ')',
      }))

      this.column_selection = [... this.reservedColumns]
    },

    fillStocksOptions(stocks) {
      this.columnNamesOptions = []
      let columnOptions = new Map()
      const storeMap = new Map(this.storeOptions.map(a => [a.value, a.text]))

      stocks.forEach(({ Stock, StockProduct }) => {
        StockProduct.forEach(stock_product => {
          const store_name = storeMap.get(stock_product.store_id)
          const key = `${stock_product.stock_id}-${stock_product.store_id}`

          if (!columnOptions.has(key)) {
            columnOptions.set(key, {
              id: Stock.id,
              value: Stock.id,
              key: Stock.id,
              name: Stock.name,
              stockType: Stock.stock_type,
              nSlots: Stock.n_slots,
              store_id: stock_product.store_id,
              store_name: store_name,
              desglose: Stock.desglose,
              quantity: stock_product.quantity,
              identificadores: [this.mountIdentifierOption(store_name, Stock, stock_product)],
              text: `${Stock.name} (1)`,
            })
          } else {
            const option = columnOptions.get(key)
            option.identificadores.push(this.mountIdentifierOption(store_name, Stock, stock_product))
            option.quantity = option.identificadores.length
            option.text = `${Stock.name} (${option.quantity})`
          }

        })

        this.columnNamesOptions = Array.from(columnOptions.values())
      });

    },

    mountIdentifierOption(store_name, stock, identifier) {
      let identificador = {}

      identificador['id'] = identifier.id
      identificador['key'] = identifier.id
      identificador['stock_product_id'] = identifier.id
      identificador['stock_id'] = identifier.stock_id
      identificador['store_id'] = identifier.store_id
      identificador['name'] = stock.name
      identificador['stockType'] = stock.stock_type
      identificador['store_name'] = store_name
      identificador['apt_id'] = identifier.apt_id
      identificador['quantity'] = identifier.quantity
      identificador['nSlots'] = stock.n_slots
      identificador['desglose'] = stock.desglose
      identificador['quantitySelected'] = 1
      identificador['product_identifier'] = identifier.product_identifier
      identificador['product_identifier_prov'] = identifier.product_identifier_prov
      identificador['value'] = identifier.id
      identificador['text'] = (identifier.product_identifier_prov) ? identifier.product_identifier_prov : identifier.product_identifier

      return identificador
    },

    fillStoreOptions(stores) {
      this.storeOptions = stores.map((a) => ({
        key: a.Store.key,
        text: a.Store.name,
        value: a.Store.id,
      }))
    },

    updateColumnReservation() {
      this.isLoading = true
      const columns = this.column_selection.map(a => a.stock_product_id)
      hapiickApi().post('/v1/reservations/columns/update', {
        admin_id: JSON.parse(localStorage.admin).id,
        column_reservation_id: this.id,
        columns: columns
      })
        .then(response => {
          this.reservedColumns = [... this.column_selection]
          userNotification('success', 'La reserva se ha actualizado correctamente', '', 2500)
        })
        .catch((error) => console.log(`Error updateColumnReservation: ${error}`))
        .finally(() => {
          this.isLoading = false
        })
    },

    editReservationName() {
      this.editName = true
      this.$refs.nameInput.focus()
    },

    saveEditName() {
      hapiickApi().post('/v1/reservations/update', {
        admin_id: JSON.parse(localStorage.admin).id,
        column_reservation_id: this.id,
        name: this.data.name
      })
        .then(response => {
          this.name_orig = this.data.name
        })
        .catch((error) => console.log(`Error saveEditName: ${error}`))
        .finally(() => {
          this.editName = false
        })
    },

    cancelEditName() {
      this.editName = false
      this.data.name = this.name_orig
    },

    deleteColumnReservationConfirm() {
      this.isDeleting = true
      this.$swal.fire({
        type: 'question',
        title: `¿Quieres eliminar la reserva ${this.data.name}?`,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Confirmar'
      }).then((result) => {
        if (result.value) {
          this.deleteColumnReservation()
        } else {
          this.isDeleting = false
        }
      }).catch((error) => {
        console.log(`Error deleteColumnReservationConfirm: ${error}`)
        this.isDeleting = false
      })
    },

    deleteColumnReservation() {
      hapiickApi().post('/v1/reservations/delete', {
        admin_id: JSON.parse(localStorage.admin).id,
        column_reservation_id: this.data.id
      })
        .then((response) => {
          if (response.data.status === 'OK') {
            userNotification('success', 'La reserva ha sido eliminada', '', 2500)
            this.goTo('/inventory/column/reservation/list')
          } else {
            userNotification('error', 'No se ha podido eliminar la reserva', '', 0)
          }
        })
        .catch(error => this.userNotification('error', 'No se ha podido eliminar la reserva', error, 0))
        .finally(() => this.isDeleting = false)
    },

    goTo(where) {
      this.$router.push(where)
    },
  },
  components: {
    'selectStock': selectStock
  }
}
</script>

<style scoped>
#idBtn {
  text-align: center;
  margin-top: 20px;
}

.margin-button {
  margin-right: 20px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Inventory/columnBookingInfo.vue